export const addTrackApiData = (dataObject) => {
  let trackData = JSON.parse(localStorage.getItem('trackData') ?? '[]');
  trackData = [...trackData, dataObject];
  localStorage.setItem('trackData', JSON.stringify(trackData));
}

export const takeAction = (data) => {
  let trackData = JSON.parse(localStorage.getItem('trackData') ?? '[]');
  if (trackData?.length > 100) {
    // some action to send data and empty array
    addTrackApiData(data)
  } else {
    addTrackApiData(data)
  }
}

export const getTrackData = () => {
  let trackData = JSON.parse(localStorage.getItem('trackData') ?? '[]');
  return trackData
}

export const clearTrackData = () => {
  localStorage.setItem('trackData', '[]')
}